import { Send } from "lucide-react";

/**
 * «Файл ушёл в Telegram» — и, если знаем куда, ссылка прямо на сообщение.
 *
 * Без ссылки строка была тупиком: контент-мейкер видел, что ролик уехал, и шёл
 * искать его в канале руками. Ролики, доставленные до того, как мы начали
 * запоминать чат, ссылки не имеют — выдуманный адрес увёл бы в чужой канал,
 * поэтому для них остаётся прежняя строка.
 */
export function DeliveryLine({ telegramUrl }: { telegramUrl?: string | null }) {
  const className = "flex items-center gap-1.5 text-[13px] font-medium text-publish-fg";

  if (!telegramUrl) {
    return (
      <span className={className}>
        <Send className="size-4" />
        Файл ушёл в Telegram
      </span>
    );
  }

  return (
    <a href={telegramUrl} target="_blank" rel="noreferrer" className={`${className} underline underline-offset-2`}>
      <Send className="size-4" />
      Файл ушёл в Telegram — открыть
    </a>
  );
}
